import { render, staticRenderFns } from "./GbqManagement.vue?vue&type=template&id=b7d51d56&scoped=true&"
import script from "./GbqManagement.vue?vue&type=script&lang=js&"
export * from "./GbqManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d51d56",
  null
  
)

export default component.exports